<template>
  <div class="team pl-4 pr-4 pt-8 pb-8">
    <div class="grid grid-cols-12">
      <div class="col-span-12 sm:col-span-10 sm:col-start-2 xl:col-span-3 xl:col-start-3 text-center pr-4">
        <div id="avatar"></div>
        <Headline content="Romy Wagner" />
        <h3>Logopädin und Praxisinhaberin</h3>
      </div>
      <div class="col-span-12 sm:col-span-10 sm:col-start-2 xl:col-span-5 xl:col-start-6 pl-4 content-center">
        <div class="text">
          <p>
            Im Jahr 2011 habe ich meine Ausbildung zur staatlich anerkannte Logopädin an der SRH-Fachschule für
            Logopädie in Bonn erfolgreich abgeschlossen. Seitdem konnte ich umfangreiche Erfahrung in der
            logopädischen Praxis sammeln: Über 13 Jahre war ich als angestellte Logopädin tätig und
            durfte später auch die fachliche Leitung einer sprachtherapeutischen und logopädischen Praxis übernehmen.
          </p>
          <p>
            Mit großer Freude und Engagement habe ich im Oktober 2024 den nächsten Schritt gewagt und meine eigene
            logopädische Praxis in Troisdorf-Spich eröffnet. Hier setze ich meine Leidenschaft für die Logopädie
            und meine langjährige Erfahrung ein, um meine Patient*innen auf ihrem Weg individuell und kompetent
            zu begleiten.
          </p>
          <p>
            Ich freue mich darauf, Sie in meiner Praxis willkommen zu heißen!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Headline from "@/components/Headline.vue";

export default {
  name: "Romy",
  components: {
    Headline
  }
};
</script>

<style scoped lang="scss">
.team {
  background-color: $color-background;
}
h3 {
  color: $color-secondary;
  font-size: $font-size-larger;
}
#avatar {
  display: inline-block;
  background-image: url('@/assets/praxisbilder/romy.png');
  width: 200px;
  height: 200px;
  background-size: cover;
  background-position: top center;
  border-radius: 50%;
  border: 5px solid white;
}
</style>